export const userOptions = {
  WEB_USER: "Web User",
  MOBILE_USER: "Mobile User"
};

export const scheduleOptions = {
  SCHEDULE_NOW: "Now",
  SCHEDULE_LATER: "Later"
};

export const notificationEndpointOptions = {
  SMS: "SMS",
  PUSH: "PUSH"
};

export enum MessagingSetOptions {
  MAINTENANCE = 15
}

export enum MessagingTemplateConstants {
  CLOC = "{CLOC}",
  DATE = "{DATE}",
  FROM = "{FROM}",
  TO = "{TO}"
}
